import { DatePicker, Space } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

function DataPicker({ getDate }: any) {
  const handleChangeDate = (range: any) => {
    if (range) {
      const valueOfInput1 = moment(range[0]).format('YYYY-MM-DD');
      const valueOfInput2 = moment(range[1]).format('YYYY-MM-DD');
      getDate(valueOfInput1, valueOfInput2);
    } else {
      getDate();
    }
  };
  const dateFormat = 'YYYY/MM/DD';
  return (
    <Space direction="vertical" size={12} className="dataPicker">
      <RangePicker
        style={{ color: 'white' }}
        placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
        onChange={handleChangeDate}
        format={dateFormat}
      />
    </Space>
  );
}

export default DataPicker;
